import { Injectable } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { BehaviorSubject, Observable, filter } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TcProgressBarService {
    private bufferValue: BehaviorSubject<number>;
    private mode: BehaviorSubject<string>;
    private value: BehaviorSubject<number>;
    private visible: BehaviorSubject<boolean>;

    constructor(
        private router: Router
    ) {
        this.init();
    }

    get getBufferValue(): Observable<any> {
        return this.bufferValue.asObservable();
    }

    setBufferValue(value: number): void {
        this.bufferValue.next(value);
    }

    get getMode(): Observable<any> {
        return this.mode.asObservable();
    }

    setMode(value: 'determinate' | 'indeterminate' | 'buffer' | 'query'): void {
        this.mode.next(value);
    }

    get getValue(): Observable<any> {
        return this.value.asObservable();
    }

    setValue(value: number): void {
        this.value.next(value);
    }

    get getVisible(): Observable<any> {
        return this.visible.asObservable();
    }

    // Privates

    private init(): void {
        // Initialize the behavior subjects
        this.bufferValue = new BehaviorSubject(0);
        this.mode = new BehaviorSubject('indeterminate');
        this.value = new BehaviorSubject(0);
        this.visible = new BehaviorSubject(false);

        // Subscribe to the router events to show/hide the loading bar
        this.router.events
            .pipe(filter((event) => event instanceof NavigationStart))
            .subscribe(() => {
                this.show();
            });

        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd || event instanceof NavigationError || event instanceof NavigationCancel)
            )
            .subscribe(() => {
                this.hide();
            });
    }

   // General

    show(): void {
        this.visible.next(true);
    }

    hide(): void {
        this.visible.next(false);
    }
}

